import { OrganisationCategoryValue, WorkflowDialogWidth, WorkflowType } from "@common/ADAPT.Common.Model/embed/workflow";
import { ImplementationKitArticle } from "@common/implementation-kit/implementation-kit-article.enum";
import { buildLocalWorkflow } from "@org-common/lib/workflow/workflow.interface";
import { WorkflowIdentifier } from "@org-common/lib/workflow/workflow-identifier.enum";

export const buildTrustPsychologicalSafetyWorkflowName = "Build trust & psychological safety";

export const buildTrustPsychologicalSafetyWorkflow = buildLocalWorkflow({
    name: buildTrustPsychologicalSafetyWorkflowName,
    workflowId: WorkflowIdentifier.BuildTrustPsychologicalSafety,
    type: WorkflowType.Journey,
    dialogWidth: WorkflowDialogWidth.ExtraLarge,
    overview: "To have a fully effective leadership team, ensure you have a strong foundation and every member of the team feels safe.",
    category: OrganisationCategoryValue.EffectiveLeadershipTeam,
    articleSlug: ImplementationKitArticle.ComingSoon, // a coming soon HelpJuice document
    ordinal: 20,
});
